<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>


                    <!-- =============================================
                         DİĞER PROGRAMLAR:
                         E. Student's Right to Cancel & Refund Policy
                         ============================================ -->
                    <template>
                        <div>
                            <p class="font-weight-bold">E. STUDENT'S RIGHT TO CANCEL (WITHDRAWAL/LEAVES OF ABSENCE) AND REFUND POLICY </p>
                        </div>
                        <div>
                            <p>If a student elects to withdraw from a specific course or the university altogether, the following refund schedule will be used to determine any outstanding financial obligation for which the student may be responsible. </p>
                        </div>
                        <div class="mb-4">
                            <h4 class="fs-6 fs-md-5 fw-bold mb-2">Fall and Spring Semesters</h4>
                            <b-table-simple
                                responsive
                                striped
                                hover
                                class="mb-3"
                            >
                                <b-thead>
                                    <b-tr>
                                    </b-tr>
                                </b-thead>
                                <b-tbody>
                                    <b-tr
                                        v-for="(menu, j) in fallSpringData"
                                        :key="'fall-spring-' + j"
                                        class="py-2 py-md-3"
                                    >
                                        <b-td class="fs-6 fs-md-5 col-6 col-md-4">{{ menu.key }}</b-td>
                                        <b-td class="fs-6 fs-md-5">
                                            <span v-html="menu.value"></span>
                                        </b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </div>

                        <div class="mb-4">
                            <h4 class="fs-6 fs-md-5 fw-bold mb-2">Summer Semester</h4>
                            <b-table-simple
                                responsive
                                striped
                                hover
                                class="mb-3"
                            >
                                <b-thead>
                                    <b-tr>
                                    </b-tr>
                                </b-thead>
                                <b-tbody>
                                    <b-tr
                                        v-for="(menu, j) in summerData"
                                        :key="'summer-' + j"
                                        class="py-2 py-md-3"
                                    >
                                        <b-td class="fs-6 fs-md-5 col-6 col-md-4">{{ menu.key }}</b-td>
                                        <b-td class="fs-6 fs-md-5">
                                            <span v-html="menu.value"></span>
                                        </b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </div>

                        <div>
                            <p>Refunds exclude all mandatory and as-applicable fees and deposits, which are non-refundable. If the student has not made any payments on the date of the withdrawal request, BAU will bill the student for the due amount according to the schedule above. If a student is participating in a payment plan and the installment payment is insufficient to cover the student's obligation according to the schedule above, then BAU will send the student a bill for the difference.</p>
                        </div>
                        <div>
                            <p>If the student wishes to transfer their SEVIS record to another institution prior to or during the semester, BAU will not refund any portion of their tuition or fees.<strong>Additionally, the student will be required to pay a processing fee of $ 2,000.</strong> </p>
                        </div>
                        <div>
                            <p>All refund requests must be submitted within sixty (60) days following the date that you either complete or withdraw from your program. A request for withdrawal must be initiated on MyBAU or submitted directly to the registrar to officially withdraw from BAU. No refund will be honored without the withdrawal request initiated on MyBAU or submitted to the registrar.  The official withdrawal date for a refund calculation will be taken from the date the online request is received on MyBAU or by the registrar.</p>
                        </div>
                        <div>
                            <p>
                                All refunds will be issued in United States Dollars, minus bank transfer and processing fees, as well as any fees incurred for a rejected payment. All refunds will be processed within 45 days of receiving an accurate and complete refund submission, subject to finance approval. Please refer to the refund policy in the Academic Catalog for additional information before submitting your request.
                            </p>
                        </div>
                        <div>
                            <p>For more information, you should refer to your tuition deposit letter. </p>
                        </div>
                    </template>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row  justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-1"
                                        v-model="form.status"
                                        name="checkbox-1"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox>

                                    <div>
                                        <span>I confirm that the information given in this section is true, complete, and accurate section E.</span>
                                    </div>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            form: {},
            fallSpringData: [
                { key: "Before the semester starts", value: "100%" },
                { key: "1st and 2nd Week of the Semester", value: "50%" },
                { key: "3rd and 4th Weeks of the Semester", value: "25%" },
                { key: "After 4th week", value: "No refund" }
            ],
            summerData: [
                { key: "Before the semester starts", value: "100%" },
                { key: "1st Week of the Semester", value: "50%" },
                { key: "2nd Week of the Semester", value: "25%" },
                { key: "After 3rd week", value: "No refund" }
            ]
        }
    },
    computed: {
        ...mapGetters({
            formData: "enrollmentAgreementForm/formData"
        })
    },
    created() {
        window.scrollTo(0,0)
    },
    methods: {
        async next(){
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid){
                this.$emit('next',1)
            }
        },
    }
}
</script>
